import { GlobalConfigType } from 'actions/global.config.type'
import { getProductTypeLabel, getProductTypeOptionsMap } from 'config/loan.constants'
import { FieldOrigin } from 'config/loan.input.visibility.type'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { store } from 'reducers'

const emptyFields = {}

const loanStructureFields = (state?: any) => {
  const source = state || store.getState()
  const loanFields = source?.globalConfigReducer?.[GlobalConfigType.LoanFields]
  return loanFields?.[FieldOrigin.LoanStructure] || emptyFields
}

/** Product types visible right now, including custom types saved on Loan Field Properties. */
export const currentProductTypeOptionsMap = (): Record<string, string> =>
  getProductTypeOptionsMap(loanStructureFields())

export const currentProductTypeOptions = (): string[] => Object.keys(currentProductTypeOptionsMap())

export const currentProductTypeLabel = (productType?: string | null): string =>
  getProductTypeLabel(productType, loanStructureFields())

export const useProductTypeOptions = () => {
  const fieldProperties = useSelector((state: any) => loanStructureFields(state))
  return useMemo(() => {
    const optionsMap = getProductTypeOptionsMap(fieldProperties)
    return {
      fieldProperties,
      optionsMap,
      options: Object.keys(optionsMap),
      label: (value?: string | null) => getProductTypeLabel(value, fieldProperties),
    }
  }, [fieldProperties])
}
